// 「편집 내용 복사」 의 브라우저 배선 — 클립보드 쓰기와 성공·실패 토스트.

import { toast } from "sonner";

import type { CopyEditsDeps } from "@buildpy/core/modules/quote/editor/copy-edits";

export const clipboardCopyDeps = (): CopyEditsDeps => ({
  writeText: (text) => navigator.clipboard.writeText(text),
  success: (title, opts) => toast.success(title, opts),
  error: (message) => toast.error(message),
});
